import type { ITreeAncestorCouple } from '../model/ITreeAncestorCouple'

export function getTreeAncestorRelationship(
	tac: ITreeAncestorCouple,
	isMale: boolean,
	levelMod = 0,
): string | undefined {
	if (tac.level == null) return undefined
	const level = tac.level + levelMod
	let result: [string | undefined, string | undefined] = [undefined, undefined]
	if (level === 1) {
		result = isMale ? [`apa`, `apja`] : [`anya`, `anyja`]
	} else if (level === 2) {
		result = isMale ? [`nagyapa`, `nagyapja`] : [`nagyanya`, `nagyanyja`]
	} else if (level === 3) {
		result = isMale ? [`dédapa`, `dédapja`] : [`dédanya`, `dédanyja`]
	} else if (level === 4) {
		result = isMale ? [`ükapa`, `ükapja`] : [`ükanya`, `ükanyja`]
	} else if (level === 5) {
		result = isMale ? [`szépapa`, `szépapja`] : [`szépanya`, `szépanyja`]
	} else if (level > 5) {
		const it = getTreeAncestorRelationship(tac, isMale, levelMod - 5)
		result = [`szépszülő ${it}`, `szépszülőjének ${it}`]
	}
	return result[levelMod === 0 ? 0 : 1]
}
